import React, { useState } from "react"
import { Button, Input, message, Modal } from "antd"
import { accountEditRemark, GetAuditEditRemark } from "../../../../../../services/dct/DctService"

interface RemarkModalProps {
  subjectId: string
  content: string
  onClose: (reload: boolean)=> void
}
const RemarkModal: React.FC<RemarkModalProps> = ({ onClose, content, subjectId })=> {
  const [remark, setRemark] = useState(content)

  const handleConfirm = async()=> {

    const { code } = await GetAuditEditRemark({
      subjectId,
      remark,
    })

    if (code === 0) {
      message.success('备注成功')
      onClose(true)
    }
  }

  return  (
    <Modal
      open
      title="请输入备注信息"
      onOk={handleConfirm}
      onCancel={()=> onClose(false)}
      okText="确定"
      cancelText="取消"
    >
      <Input.TextArea onChange={({ target })=> setRemark(target.value)} value={remark} placeholder="请输入备注信息"/>
  </Modal>
  )
}

export default RemarkModal
